<template>
  <div>
    <h1 class="font-extrabold text-4xl md:text-7xl tracking-tight">Starter Application</h1>
  </div>
</template>

<script>
export default {
  name: 'NewAppHome',
  props: ['prop1', 'prop2'],
  data () {
    return {
      model: {}
    }
  },
  mounted () {
  },
  methods: {
    importantMethodHere () {
    }
  }
}
</script>
